import{PAGINATION_DEFAULT_ROWS_PER_PAGE_OPTIONS as o,PAGINATION_DEFAULT_ROWS_PER_PAGE as a}from"@danfoss/mosaic-core";const e=o.map((o=>({label:String(o),value:o,default:o===a})));export{e as DEFAULT_PAGINATION_ROWS_PER_PAGE_OPTIONS};
